module.exports = __webpack_public_path__ + "static/media/MENOSPH.81e07b84.png";